// ye maine update kiya card aur star mark k update k liye alg alg click hone p chll rha hai 
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons"; 
import { PieChart, Pie, Cell, Tooltip } from "recharts";
// import logo2 from "../dashboard/dots.png";
import DetailsDashboard from "./DetailsDashboard";

const Dashboard = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [originalData, setOriginalData] = useState([]); // Original order store karega
  const [isStarred, setIsStarred] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/validAudit/agents");
        const apiData = await response.json();
  
        const storedStars = JSON.parse(localStorage.getItem("starredAgents")) || {};
  
        const transformedData = apiData.map((org, index) => ({
          ...org,
          originalIndex: index,
          data: [
            { name: "Accepted", value: org.Accepted, color: "#FF0080" },
            { name: "Rejected", value: org.Rejected, color: "#1E3A8A" },
            { name: "Pending", value: org.Pending, color: "#F59E0B" },
          ],
        }));
  
        setOriginalData(transformedData);
        setIsStarred(storedStars);
  
        // Reorder chartData based on stored stars
        const starred = transformedData.filter((_, i) => storedStars[i]);
        const unstarred = transformedData.filter((_, i) => !storedStars[i]);
  
        setChartData([...starred, ...unstarred]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, []);
  

  const handleCardClick = (event, index) => {
    if (event.target.closest(".star-icon")) {
      return; // Ignore click if it’s on star
    }
    setSelectedCard(index);
  };

  const handleStarClick = (event, index) => {
    event.stopPropagation();
  
    setIsStarred((prev) => {
      const updatedStars = { ...prev, [index]: !prev[index] };
  
      // Save to localStorage
      localStorage.setItem("starredAgents", JSON.stringify(updatedStars));
  
      const starred = originalData.filter((_, i) => updatedStars[i]);
      const unstarred = originalData.filter((_, i) => !updatedStars[i]);
  
      setChartData([...starred, ...unstarred]);
  
      return updatedStars;
    });
  };
 
  

  return (
    <div style={styles.mainContainer}>
      <h1 style={styles.heading}>Dashboard</h1>
      <div style={styles.dashboardContainer}>
        {chartData.map((org, index) => (
          <div key={org.originalIndex} style={styles.cardWrapper} onClick={(e) => handleCardClick(e, index)}>
            <div style={styles.chartContainer}>
              <div style={styles.headerContainer}>
                <h3 style={styles.chartTitle}>{org.orgName}</h3>
              </div>
              <PieChart width={250} height={200} style={styles.pieChart}>
                <Pie
                  data={org.data}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={100}
                  dataKey="value"
                  labelLine={false}
                  label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
                    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
                    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
                    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
                    return (
                      <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
                        {`${(percent * 100).toFixed(0)}%`}
                      </text>
                    );
                  }}
                >
                  {org.data.map((entry, i) => (
                    <Cell key={`cell-${i}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
              <div style={styles.legendContainer}>
                {org.data.map((entry, i) => (
                  <div key={i} style={{ ...styles.legendItem, color: "#767676" }}>
                    <span style={{ ...styles.legendDot, backgroundColor: entry.color }}></span>
                    {entry.name} <span style={styles.legendValue}>{entry.value}</span>
                  </div>
                ))}
              </div>
              {/* <div style={styles.logoContainer}>
                  <FontAwesomeIcon
                    icon={faStar}
                    className="star-icon"
                    style={{
                      fontSize: "15px",
                      color: isStarred[org.originalIndex] ? "#FF0080" : "#D3D3D3",
                      cursor: "pointer",
                      transition: "color 0.2s ease-in-out",
                    }}
                    onClick={(e) => handleStarClick(e, org.originalIndex)}
  />
  <div style={styles.tags}>
        <span style={styles.tag}>Indonesia</span>
      </div>
</div> */}
<div style={styles.logoContainer}>
  <FontAwesomeIcon
    icon={faStar}
    style={{
      fontSize: "15px",
      color: isStarred[org.originalIndex] ? "#FF0080" : "#D3D3D3",
      cursor: "pointer",
      marginRight: "8px",
      display: "flex",
      alignItems: "center"
    }}
    onClick={(e) => handleStarClick(e, org.originalIndex)}
  />

  <span style={styles.tag}>Indonesia</span>
</div>


            </div>
          </div>
           ))}
            
      </div>

      {selectedCard !== null && (
         <div style={styles.overlay} onClick={() => setSelectedCard(null)}>
         <div style={styles.slidePanel} onClick={(e) => e.stopPropagation()}>
           <button style={styles.closeButton} onClick={() => setSelectedCard(null)}>X</button>
           <DetailsDashboard
             org={chartData[selectedCard]}
             closePanel={() => setSelectedCard(null)}
             isStarred={isStarred[chartData[selectedCard].originalIndex]} // ⭐ Star status bhej rahe
             onStarToggle={(e) => handleStarClick(e, chartData[selectedCard].originalIndex)} // 🔄 Toggle function
           />
         </div>
       </div>
      )}
    </div>
  );
};


// const styles = {
//   mainContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "20px",
//     width: "100%",
//   },
//   heading: {
//     fontSize: "24px",
//     fontWeight: "bold",
//     marginBottom: "10px",
//         alignSelf: "flex-start", 
//   },
//   dashboardContainer: {
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "20px",
//     justifyContent: "center",
//   },
//   cardWrapper: {
//     cursor: "pointer",
//   },
//     chartContainer: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       background: "#fff",
//       padding: "16px",
//       borderRadius: "10px",
//       boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
//       width: "250px",
//       position: "relative",
//       transition: "transform 0.2s ease-in-out",
//     },
//   headerContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "100%",
//     marginBottom: "10px",
//   },
//   chartTitle: {
//     fontSize: "15px",
//     fontWeight: "normal",
//     flexGrow: 1,
//     color: "#000000DE",
//     maxWidth: "220px", // 🔥 Ensures it does not overflow
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis", // 🔥 Adds "..." if text is too long
//     textAlign: "center",
//   },
//   pieChart: {
//     position: "relative",
//   },
//   legendContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "flex-start",
//     marginBottom: "30px",
//     width: "100%",
//   },
//   legendItem: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     width: "100%",
//     fontSize: "11px",
//     margin: "4px 0",
//   },
//   legendDot: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     display: "inline-block",
//     marginRight: "8px",
//   },
//   legendValue: {
//     marginLeft: "auto",
//   },
//   tagContainer: {
//     display: "flex",
//     gap: "5px",
//     marginTop: "-18px",
//     marginRight: "150px",
//   },
//   tag: {
//     padding: "4px 8px",
//     borderRadius: "9px",
//     fontSize: "9px",
//     border: "1px solid #E0E0E0",
//   },
//   logoContainer: {
//     display: "flex",
//     justifyContent: "flex-start",
//     alignItems: "center",
//     marginTop: "auto",       // Push to bottom
//     width: "100%",           // So it aligns with card width
//     paddingLeft: "10px",     // For left spacing
//     paddingBottom: "10px",   // Optional: give some space from bottom
//   },
//   logo: {
//     width: "30px",
//     height: "30px",
//   },
//   overlay: {
//     position: "fixed",
//     top: 0,
//     right: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0,0,0,0.3)",
//     display: "flex",
//     justifyContent: "flex-end",
//   },
//   slidePanel: {
//     width: "400px",
//     height: "100%",
//     backgroundColor: "#fff",
//     boxShadow: "-2px 0px 10px rgba(0,0,0,0.2)",
//     padding: "20px",
//     position: "relative",
//   },
// };
const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Changed from "center" to "flex-start"
    justifyContent: "flex-start", // Changed from "center" to "flex-start"
    padding: "10px",
    width: "100%",
  },
    tags: {
    display: "flex",
    gap: "5px",
    marginBottom: "15px",
  },
  heading: {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "0px",
    alignSelf: "flex-start", 
  },
  dashboardContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
    justifyContent: "flex-start"// Changed from "center" to "flex-start"
     // Added to ensure full width
  },
  cardWrapper: {
    cursor: "pointer",
  },
  chartContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#fff",
    padding: "26px",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    width: "295px",
    position: "relative",
    transition: "transform 0.2s ease-in-out",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginBottom: "10px",
  },
  chartTitle: {
    fontSize: "15px",
    fontWeight: "normal",
    flexGrow: 1,
    color: "#000000DE",
    maxWidth: "220px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  },
  pieChart: {
    position: "relative",
  },
  legendContainer: {
    display: "flex",
     alignItems: "center",
    flexDirection: "column",
    // alignItems: "flex-start",
    marginBottom: "30px",
    width: "100%",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    fontSize: "11px",
    margin: "4px 0",
  },
  legendDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "8px",
  },
  legendValue: {
    marginLeft: "auto",
  },
  tagContainer: {
    display: "flex",
    gap: "5px",
    marginTop: "-18px",
    marginRight: "150px",
  },
  tag: {
    padding: "4px 8px",
    borderRadius: "9px",
    fontSize: "9px",
    border: "1px solid #E0E0E0",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "auto",
    width: "100%",
    paddingLeft: "10px",
    paddingBottom: "10px",
  },
  logo: {
    width: "30px",
    height: "30px",
  },
  overlay: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    justifyContent: "flex-end",
  },
  slidePanel: {
    width: "550px",
    height: "100%",
    backgroundColor: "#fff",
    boxShadow: "-2px 0px 10px rgba(0,0,0,0.2)",
    padding: "39px",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    padding: "5px 10px",
  },
};
export default Dashboard;




